var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.535,
    height: 24,
    viewBox: "0 0 22.535 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help_Icon",
    "data-name": "Help Icon",
    transform: "translate(0.25 0.376)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(7.352 16.624)",
    fill: "#ffb600",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 16,
    fontFamily: "Nunito-Regular, Nunito"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("g", {
    id: "Group_127986",
    "data-name": "Group 127986",
    transform: "translate(22) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31035",
    "data-name": "Path 31035",
    d: "M10.96,22A11,11,0,0,1,6.445.99,10.95,10.95,0,0,1,21.16,6.875a.754.754,0,1,1-1.386.568,9.251,9.251,0,0,0-6.421-5.636,9.479,9.479,0,1,0,6.385,12.8c.127-.305.29-.562.644-.615a.735.735,0,0,1,.8,1.042,13.841,13.841,0,0,1-.933,1.832,10.723,10.723,0,0,1-7.5,4.956C12.156,21.924,11.555,21.943,10.96,22Z",
    fill: "#242424",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help-Icon.22ff7fc4e5a4187d593c3bb275189f53.svg";
export { ForwardRef as ReactComponent };